import { Grid, TextField, InputAdornment } from "@mui/material";
import { forwardRef } from "react";
import {
  Wallet,
  setTransferDialog,
} from "../../../../../app/slices/walletSlice";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import { showNotification } from "../../../../../app/slices/notificationSlice";
import { NumericFormat } from "react-number-format";
import {
  HiOutlineArrowsRightLeft,
  HiOutlineBanknotes,
  HiOutlineDocumentText,
} from "react-icons/hi2";
import FormDialog, { SectionCard } from "../../../../../components/FormDialog";

const TransferForm = (props) => {
  const dispatch = useDispatch();
  const _Wallet = useSelector((state) => state.wallet);
  const transactionsSearchBody = useSelector(
    (state) => state.wallet.transactionsSearchBody,
  );
  const { control, handleSubmit } = useForm({
    defaultValues: {},
  });

  const onSubmit = (data) => {
    data.pos_number = props.userData.pos_number;
    if (props.userData.is_representative) {
      dispatch(
        showNotification({
          message: "هذه العملية مخصصة لنقطة البيع فقط",
          type: "error",
        }),
      );
    } else {
      dispatch(Wallet.transfer(data, transactionsSearchBody)).then((x) => {
        dispatch(setTransferDialog());
      });
    }
  };

  const handlDialog = () => {
    dispatch(setTransferDialog());
  };

  const NumericFormatCustom = forwardRef(
    function NumericFormatCustom(props, ref) {
      const { onChange, ...other } = props;

      return (
        <NumericFormat
          {...other}
          getInputRef={ref}
          onValueChange={(values) => {
            onChange({
              target: {
                name: props.name,
                value: values.value,
              },
            });
          }}
          thousandSeparator
          valueIsNumericString
        />
      );
    },
  );

  return (
    <FormDialog
      open={_Wallet.transferDialog}
      onClose={handlDialog}
      icon={<HiOutlineArrowsRightLeft />}
      title={"مناقلة رصيد لنقطة البيع"}
      subtitle="أدخل معلومات المناقلة ثم احفظ"
      onSubmit={handleSubmit(onSubmit)}
    >
      <SectionCard icon={<HiOutlineBanknotes />} title="معلومات المناقلة">
        <Grid item xs={12}>
          <Controller
            name="pos_number"
            control={control}
            render={({ field }) => (
              <TextField
                required
                size="small"
                label="رقم نقطة البيع"
                fullWidth
                {...field}
                value={props.userData.pos_number}
                disabled
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            name="amount"
            control={control}
            render={({ field }) => (
              <TextField
                required
                size="small"
                label="المبلغ الكلي"
                fullWidth
                {...field}
                InputProps={{
                  inputComponent: NumericFormatCustom,
                  startAdornment: (
                    <InputAdornment position="start">IQD</InputAdornment>
                  ),
                }}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            name="cash"
            control={control}
            render={({ field }) => (
              <TextField
                required
                size="small"
                label="المبلغ المدفوع"
                fullWidth
                {...field}
                InputProps={{
                  inputComponent: NumericFormatCustom,
                  startAdornment: (
                    <InputAdornment position="start">IQD</InputAdornment>
                  ),
                }}
              />
            )}
          />
        </Grid>
      </SectionCard>
      <SectionCard icon={<HiOutlineDocumentText />} title="الملاحظات">
        <Grid item xs={12}>
          <Controller
            name="note"
            control={control}
            render={({ field }) => (
              <TextField
                size="small"
                label="ملاحظات"
                fullWidth
                multiline
                rows={4}
                {...field}
              />
            )}
          />
        </Grid>
      </SectionCard>
    </FormDialog>
  );
};

export default TransferForm;
